import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let app_id = useDataValue({
    viewPath: props.viewPath,
    context: 'check_in',
    path: 'app_id',
  })

  let location_id = useDataValue({
    context: 'check_in',
    path: 'location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
      app_id,
    },
    pause: !location_id || !app_id,
  }
}
